import styled from "styled-components"

export const CheckableLabel = styled.label`
  color: ${({ theme }) => theme.header.primary};
  font-size: 16px;
  font-weight: 500;

  margin: 0 8px;
`
